<ng-container>
    <div #messageCenterContainer class="scroll-y me-n5 pe-5 h-300px h-lg-auto" style="max-height: 447px;">
        <div *ngFor="let message of messages()" class="d-flex" [ngClass]="{'justify-content-start mb-5': message.isAdmin, 'justify-content-end mb-10': !message.isAdmin}">
            
            <div class="d-flex flex-column align-items-start" *ngIf="message.isAdmin">
                <div class="d-flex align-items-center mb-2">
                    <div class="ms-3">
                        <span class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">{{message?.userName}}</span>
                        <span class="text-muted fs-7 mb-1">{{ this.convertDateTime(message.time) }}</span>
                    </div>
                </div>
                <div class="p-5 rounded text-gray-900 fw-semibold mw-lg-400px text-start user-message" [ngClass]="{'initial-message-bg': message.isInitial, 'admin-message': message.isSystemMessage}">
                    {{ message.text }}
                </div>
            </div>

            <div class="d-flex flex-column align-items-end" *ngIf="!message.isAdmin">
                <div class="d-flex align-items-center mb-2 me-n5">
                    <div class="me-3">
                        <span class="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">{{ message?.userName }}</span>
                        <span class="text-muted fs-7 mb-1 ms-2">{{this.convertDateTime(message.time) }}</span>
                    </div>
                </div>
                <div class="p-5 rounded text-gray-900 fw-semibold mw-lg-400px text-start user-message me-n3"  [ngClass]="{'admin-message': message.isSystemMessage}">
                    {{ message.text }}
                </div>
            </div>
        </div>
    </div>

    <div class="card-footer p-0 d-flex align-items-center" id="au_chat_messenger_footer">
        <div class="position-relative w-100">
            <textarea
                [value]="newMessage()"
                class="form-control form-control-flush mb-3"
                rows="2"
                maxlength="1000"
                placeholder="Type a message"
                (input)="onNewMessage($event)"
                (keydown.enter)="onEnterKey($event)"
                style="padding-right: 40px;"
            ></textarea>
            <img
                src="assets/icon-assets/png/send-message-icon.png"
                alt="Send"
                class="send-icon"
                draggable="false"
                (click)="sendMessage(newMessage())"
            />
        </div>
    </div>
</ng-container>